import { Table, TableBody, TableHeadRow, TableHeadCell } from '@client/toolkit';
import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { useTranslation } from 'react-i18next';
import { BuildingYieldRow } from '../BuildingYieldRow/building-yield-row';
import { ReportingPaths } from '../../../../reporting/reporting.router';
import { usePostStatisticsNetYieldDashboardMutation } from '@client/api';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { NoDataWidget } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';
import { useEffect } from 'react';

export const BuildingNetYieldWidget = () => {
  const { t } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFrom, selectedDateTo } = useDashboardFilters();
  const [trigger, { data, isLoading }] = usePostStatisticsNetYieldDashboardMutation();

  useEffect(() => {
    if (!selectedDateFrom || !selectedDateTo) return;

    trigger({
      startDate: selectedDateFrom,
      endDate: selectedDateTo,
      body: { buildingIds: selectedSpaceIds },
    });
  }, [selectedSpaceIds, selectedDateFrom, selectedDateTo, trigger]);

  if (!selectedDateFrom || !selectedDateTo || ((!data || data.length === 0) && !isLoading)) {
    return <NoDataWidget title={t('buildingNetYield.title')} noDataText={t('buildingNetYield.noData')} />;
  }

  return (
    <DashboardCardWrapper
      title={t('buildingNetYield.title')}
      to={ReportingPaths.NetYieldByBuilding}
      loading={isLoading}
    >
      <Table className="w-full">
        <thead className="bg-surface-base text-gray-300 border-b border-border ">
          <TableHeadRow>
            <TableHeadCell className="!font-normal">{t('buildingNetYield.name')}</TableHeadCell>
            <TableHeadCell className="!font-normal" align="right">
              {t('buildingNetYield.operatingCost')}
            </TableHeadCell>
            <TableHeadCell className="!font-normal" align="right">
              {t('buildingNetYield.grossIncome')}
            </TableHeadCell>
            <TableHeadCell className="!font-normal" align="right">
              <span dangerouslySetInnerHTML={{ __html: t('buildingNetYield.costPerSquareMeter') }} />
            </TableHeadCell>
            <TableHeadCell className="!font-normal" align="right">
              {t('buildingNetYield.buildingValue')}
            </TableHeadCell>
            <TableHeadCell className="!font-normal" align="right">
              {t('buildingNetYield.netYield')}
            </TableHeadCell>
            <TableHeadCell className="!font-normal" align="right">
              {t('buildingNetYield.changes')}
            </TableHeadCell>
          </TableHeadRow>
        </thead>
        <TableBody>
          {(data ?? []).map((building) => (
            <BuildingYieldRow key={`${building.spaceId}-${selectedDateFrom}-${selectedDateTo}`} {...building} />
          ))}
        </TableBody>
      </Table>
    </DashboardCardWrapper>
  );
};
